import * as types from './mutations/types'
import * as i18n from '@/lib/i18n'

export default {
  setLocale({commit}, locale) {
    commit(types.SET_LOCALE, locale)
  },

  getContent({commit}, locale) {
    commit(types.REQUEST_AJAX)

    return i18n
      .getContent(locale)
      .then((content) => {
        commit(types.RECEIVE_CONTENT, {content})
      })
      .finally(() => {
        commit(types.REQUESTED_AJAX)
      })
  },

  getAudio({commit}, path) {
    commit(types.REQUEST_AUDIO)

    return new Promise((resolve) => {
      const audio = new Audio()

      //audio.preload = 'metadata'

      //add event listener to audio when fullu loaded
      audio.addEventListener('canplaythrough', () => {
        resolve(audio)
      })

      audio.src = path
      audio.load()
      audio.pause()

      commit(types.PRELOADED_ASSETS, {[path]: audio})
    }).finally(() => {
      commit(types.REQUESTED_AUDIO)
    })
  },

  commitVideo({commit}, path) {
    commit(types.REQUEST_VIDEO)

    return new Promise(() => {
      const video = document.createElement('video')
      video.preload = 'auto'
      video.src = path

      video.load()
      video.pause()

      commit(types.PRELOADED_ASSETS, {[path]: video})

      video.addEventListener('canplaythrough', () => {
        commit(types.REQUESTED_VIDEO)
      })
    }).catch(() => {
      commit(types.REQUESTED_VIDEO)
    })
  },

  getImage({commit}, path) {
    commit(types.REQUEST_IMAGE)

    return new Promise((resolve) => {
      const img = new Image()

      img.addEventListener('load', () => {
        resolve(img)
      })

      img.src = path
    }).finally(() => {
      commit(types.REQUESTED_IMAGE)
    })
  }
}
